import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Layout from "../../common/Layout";
import { NavLink, useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import "../../../styles/pageStyles/userListing/userListing.css";
import Select from "@mui/material/Select";
import UserListingTable from "./UserListingTable";
import config from "../../../config/Config";

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "14px !important",
  fontFamily: "proxima-regular !important",
  padding: "0px 0px 2px 10px",
  "&:hover": {
    backgroundColor: "#067de2 !important",
    color: "#fff !important",
    "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
      color: "#OOO !important",
      fontSize: "16px !important",
    },
  },
  "&.Mui-selected": {
    backgroundColor: "#ffff !important",
  },
  "&.Mui-selected:hover": {
    color: "#fff !important",
    backgroundColor: "#067de2 !important",
  },
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  color: "#000 !important",
  fontSize: "14px !important",
  width: "175px !important",
  height: "35px !important",
  padding: "4px 4px 4px 2px !important",
  borderRadius: "5px !important",
  border: "0.5px solid #000 !important",
  fontFamily: "proxima-regular !important",
}));

const UserListing = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [userStatus, setUserStatus] = useState(0);
  const [userList, setUserList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  var userDataToMap = filteredData.length === 0 ? tableData : filteredData;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("username");
  const [userNotFound, setUserNotFound] = useState(false);
  const [tableLoader,setTableLoader]=useState(false);
  const pageSize = 8;
  const navigate = useNavigate();

  useEffect(() => {
    setTableLoader(true)
    var tokenStr = localStorage.getItem("access_token");
    fetch(`${config.baseUrl}user/`, {
      headers: { Authorization: `Bearer ${tokenStr}` },
    }).then(async (response) => {
      const result = await response.json();
      if (response.status === 201 || response.status === 200) {
        setUserList(result);
        setTableData(result);
        setTableLoader(false)
      } else if (response.status === 403) {
        setTableLoader(false)
        localStorage.setItem("access_token", "");
        navigate("/");
      }
    });
  }, []);

  useEffect(() => {
    setTableLoader(true)
    if (!searchTerm) {
      setFilteredData([]); 
      setUserNotFound(false);
      setTableLoader(false)
      return;
    }

    const results = tableData.filter((item) => {
      const query = searchTerm.toLowerCase();
      return (
        item.username.toLowerCase().includes(query) ||
        item.email.toLowerCase().includes(query) ||
        item.first_name.toLowerCase().includes(query) ||
        item.last_name.toLowerCase().includes(query)
      );
    });
    setFilteredData(results);
    setUserNotFound(results.length === 0);
    setTableLoader(false); 
  }, [searchTerm , tableData]);

  const handleStatusChange = (event) => {
    setUserStatus(event);
    if (event === "0") {
      setTableData(userList);
    } else if (event === "1") {
      let data = userList.filter((item) => item.is_active === true);
      setTableData(data);
    } else if (event === "2") {
      let data = userList.filter((item) => item.is_active === false);
      setTableData(data);
    }
  };

  RegExp.escape = function (s) {
    if (s) {
      return s.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
    }
  };

  const handleChange = (event) => {
    const regEx = new RegExp(RegExp.escape(event.target.value), "gi");
    setSearchTerm(event.target.value);
  };

  const userListingTableProps = {
    tableData,
    setTableData,
    setUserList,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    userDataToMap,
    userNotFound,
    tableLoader
  };
  return (
    <>
      <div className="user-listing-container">
        <div className="user-lisiting-head-btn-container ">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <NavLink
              style={{ textDecoration: "none", color: "white" }}
              exact
              to="/user"
            >
              <Button
                className="app-primary-btn"
                sx={{ color: "#fff", background: "#067de2" }}
              >
                <AddIcon
                  style={{
                    color: "#fff",
                    marginRight: "5px",
                    fontSize: "22px",
                  }}
                />
                <span style={{ marginTop: "4px" }}>Add user</span>
              </Button>
            </NavLink>
          </div>
        </div>
        <Grid
          container
          className="user-listing-filter-tab"
          columnSpacing={{ md: 6, lg: 10 }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 8, lg: 9 }}>
            <div className="user-listing-search-input-container">
              <div className="user-listing-search-input-search-icon">
                <SearchOutlinedIcon style={{ fill: " #067de2" }} />
              </div>
              <InputBase
                className="colors"
                type="text"
                value={searchTerm}
                onChange={handleChange}
                placeholder="Search For Username/Email/First Name/Last Name"
                inputProps={{ "aria-label": "search" }}
              />
            </div>
          </Grid>
          <Grid
            item
            className="user-listing-filter-select"
            size={{ xs: 12, sm: 12, md: 4, lg: 2 }}
          >
            <label>Active</label>
            <CustomSelect
              id="user-status"
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "0px 6px",
                },
                ".MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              value={userStatus}
              onChange={(e) => handleStatusChange(e.target.value)}
            >
              <StyledMenuItem value="0">All</StyledMenuItem>
              <StyledMenuItem value="1">Yes</StyledMenuItem>
              <StyledMenuItem value="2">No</StyledMenuItem>
            </CustomSelect>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <UserListingTable props={userListingTableProps} />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Layout(UserListing);
